import React from "react";

const items = [
  "Shows in LA, Las Vegas & San Francisco · 2026",
  "Playing Support for Joe Bonamassa & Jimmy Vivino",
  "Music Coming Soon",
  "Merch Coming Soon",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-strip"
      className="bg-vintage-rust text-vintage-cream py-4 border-y-2 border-vintage-bg overflow-hidden relative"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[...items, ...items, ...items].map((it, idx) => (
          <div key={idx} className="flex items-center gap-10 px-10">
            <span className="font-heading text-2xl tracking-[0.25em] uppercase">
              {it}
            </span>
            <span className="text-vintage-gold text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
